import { Injectable } from "@angular/core";
import { FieldsData } from "app/interfaces/document-field-data.dto";
import { Field } from "app/interfaces/fields";

@Injectable({ providedIn: 'root' })

export class FieldRenderService {

  private renderedFieldUuids = new Set<string>();

  /**
   * While adding field into content adding uuid into set
   * @param uuid 
   * @returns {void}
   */
  markRendered(uuid: string): void {
    this.renderedFieldUuids.add(uuid);
  }


  /**
   * When removing field from content also removing from set
   * @param uuid 
   * @returns {void}
   */
  unmarkRendered(uuid: string): void {
    this.renderedFieldUuids.delete(uuid);
  }


  /**
   * Checking if field is rendered in content or not
   * @param uuid 
   * @returns {boolean}
   */
  isRendered(uuid: string): boolean {
    return this.renderedFieldUuids.has(uuid);
  }



  /**
   * Marks fields as rendered based on their visibility properties.
   *
   * Iterates over the provided `fields_data` object, excluding the 'blocks' key.
   * For each field, if both `secret_hidden_field` and `semi_hidden_field` are set to `0`,
   * the field is considered visible and its UUID is passed to `markRendered` to mark it as rendered.
   *
   * @param fields_data - An object containing field data, where each key (except 'blocks') maps to a `Field`.
   */
  setMarkAsRenderedFields(fields_data: FieldsData): void {
    Object.entries(fields_data ?? {}).forEach(([key, value]) => {
      if (key !== 'blocks') {
        const field = value as Field;
        if (!field.secret_hidden_field && !field.semi_hidden_field && document.querySelector(`.drag-fields[uuid="${field.uuid}"]`)) {
          this.markRendered(field.uuid);
        }
      }
    })
  }
}
